// extracted by mini-css-extract-plugin
export default {"background":"style_background__WZXxi"};